import { useParams } from "react-router-dom"

import { NavigationProvider } from "web/contexts"

import { useFeatureFlag, useTopics, useViewGroup } from "web/hooks/data"
import { useCurrentTLO } from "web/hooks/context"

import { ObjectList } from "web/components"

import useViewOrEditTopicModal from "web/components/ViewOrEdit/ViewOrEditTopic"

import useNewTopicModal from "./New"
import routes from "web/routes/constants"

export default function TopicRecordList({
  subjectType,
  subjectId = undefined,
  route: routeProp,
  rootUrl,
  canRedirectToRootUrl,
}) {
  const routeParams = useParams()

  const topicName = !!routeProp ? routeProp[0].key : routeParams.topicName

  const { data: TLO, userCan } = useCurrentTLO() || {}
  if (!subjectId) {
    subjectId = TLO.id
  }

  const topics = useTopics({ subjectType })
  const topic = topics.find((topic) => topic.name === topicName)

  const viewGroup = useViewGroup({
    parentSubjectType: subjectType,
    parentSubjectId: subjectId,
    topicId: topic.id,
  })

  const useSSRTopicRecordModals = useFeatureFlag("ssr_topic_record_modals")

  const newTopicModal = useNewTopicModal({
    subjectType,
    topic: topic,
  })

  const userCanCreateTopicRecords = userCan("update")

  const viewOrEditTopicModal = useViewOrEditTopicModal({
    subjectType,
    topic: topic,
  })

  function handleAddTopicRecord(records) {
    if (useSSRTopicRecordModals) {
      window.Turbo.visit(
        routes.ssrNewTopicRecord(subjectType, subjectId, topicName),
        {
          frame: "modal",
        }
      )
    } else {
      newTopicModal(records)
    }
  }

  async function handleTopicRecordClick(record, list) {
    if (useSSRTopicRecordModals) {
      window.Turbo.visit(
        routes.ssrEditTopicRecord({
          subjectType: subjectType,
          subjectId: subjectId,
          topicName: topicName,
          id: record.id,
        }),
        {
          frame: "modal",
        }
      )
    } else {
      await viewOrEditTopicModal({
        recording: record,
        isCrossSubject: false,
      })

      list.refresh()
    }
  }

  return (
    <div className="-mx-3 flex min-h-0 grow flex-col lg:-mx-5">
      <NavigationProvider viewGroup={viewGroup} viewId={null}>
        <ObjectList
          subjectType={subjectType}
          subjectId={subjectId}
          topic={topic}
          availableViews={["table", "compare"]}
          defaultView="table"
          enableEdit={true}
          onAdd={userCanCreateTopicRecords ? handleAddTopicRecord : undefined}
          onItemClick={handleTopicRecordClick}
          rootUrl={rootUrl}
          canRedirectToRootUrl={canRedirectToRootUrl}
        />
      </NavigationProvider>
    </div>
  )
}
